function CourseRegistrationParticipants(params) {
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.values = {
    sequencePk: params.sequencePk
  };
}

CourseRegistrationParticipants.prototype.switchTab = function(tabType) {
  this.tabType(tabType);
};

module.exports = CourseRegistrationParticipants;
